// test2265
(2265 && 0);
